// Dummy project data for all services
export const projectData = {
  // Sports Services
  'badminton-courts': [
    {
      id: 1,
      title: 'Agrahara Badminton Club (Badminton Court)',
      builtArea: '5,400 sq ft',
      location: 'Agrahara, Bangalore',
      completionDate: '2025',
      materials: ['Synthetic Flooring', 'LED Flood Lights', 'Aluminum Posts', 'Quality Nets'],
      description: 'Professional badminton court at Agrahara Badminton Club with premium synthetic flooring and advanced lighting system.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/y4nesede_Agrahara%20badminton%20club%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/o38augd3_Agrahara%20badminton%20club%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/qs5v3j86_Agrahara%20badminton%20club%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/9kp7rva3_Agrahara%20badminton%20club%204.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/0jnpp8bs_Agrahara%20badminton%20club%205.jpg'
      ]
    },
    {
      id: 2,
      title: 'All Star Sports Arena (Badminton Court)',
      builtArea: '7,200 sq ft',
      location: 'Sampigehalli, Bangalore',
      completionDate: '2025',
      materials: ['Premium Synthetic Flooring', 'LED Lighting', 'Professional Posts', 'Quality Net Systems'],
      description: 'State-of-the-art badminton court at All Star Sports Arena Sampigehalli with professional-grade facilities.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/jtymf5i7_sampigehalli%20badminton%20court%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/sr90sh2r_sampigehalli%20badminton%20court%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/8rt7gqyv_sampigehalli%20badminton%20court%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/1xpyjoda_sampigehalli%20badminton%20court%204.jpg'
      ]
    }
  ],
  
  'tennis-courts': [
    {
      id: 1,
      title: 'TENNIS Academy (Tennis Court)',
      builtArea: '28,800 sq ft',
      location: 'Bangalore',
      completionDate: '2023',
      materials: ['Professional Court Surface', 'LED Stadium Lights', 'Steel Posts', 'Professional Net System'],
      description: 'Professional tennis court installation at TENNIS Academy with tournament-standard surface and professional lighting systems.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/tta7yipt_TENNIS%20COURT%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/6mh7u2d9_TENNIS%20COURT%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/7rfboo69_TENNIS%20COURT%203.jpg'
      ]
    }
  ],

  'basketball-courts': [
    {
      id: 1,
      title: 'HSR (Basketball Court)',
      builtArea: '5,400 sq ft',
      location: 'HSR Layout, Bangalore',
      completionDate: '2023',
      materials: ['Premium Court Flooring', 'Professional Backboards', 'Adjustable Hoops', 'LED Court Lighting'],
      description: 'Professional basketball court at HSR with premium flooring and state-of-the-art facilities.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/3rsm0bt1_Game%20theory%20HSR%20basketball%20court%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/8963covz_Game%20theory%20HSR%20basketball%20court%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/s3yubjow_Game%20theory%20HSR%20basketball%20court%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/tyeabvn3_Game%20theory%20HSR%20basketball%20court%204.jpg'
      ]
    }
  ],

  'football-turf': [
    {
      id: 1,
      title: 'Baglur Sports Arena (11A Side Football Turf)',
      builtArea: '66,000 sq ft',
      location: 'Baglur, Bangalore',
      completionDate: '2024',
      materials: ['Premium Artificial Turf', 'FIFA Standard Markings', 'Professional Goal Posts', 'Drainage System'],
      description: 'Professional 11-a-side football turf at Baglur Sports Arena with FIFA-standard specifications and premium artificial turf.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/o8vtl0v7_Football%20Court%20Baglur%20Sportss%20arena%20%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/7k769n8p_Football%20Court%20Baglur%20Sportss%20arena%20%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/c77gj6f1_Football%20Court%20Baglur%20Sportss%20arena%20%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/5l2ihhxh_Football%20Court%20Baglur%20Sportss%20arena%20%204.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/4a34yorx_Football%20Court%20Baglur%20Sportss%20arena%20%205.jpg'
      ]
    },
    {
      id: 2,
      title: 'Sparkling mindz Global School (7A Side Football Turf)',
      builtArea: '22,024 sq ft',
      location: 'Hennur, Bangalore',
      completionDate: '2024',
      materials: ['Artificial Turf', 'Youth-Friendly Surface', 'Mini Goal Posts', 'Safety Fencing'],
      description: 'Professional 7-a-side football turf at Sparkling mindz Global School designed for student recreation and sports activities.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/u72o94y1_Football%20Court%20Sparkling%20minds%20%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/yu71605b_Football%20Court%20Sparkling%20minds%20%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/q706l92p_Football%20Court%20Sparkling%20minds%20%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/uiw09z6t_Football%20Court%20Sparkling%20minds%20%204.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/vd8j9su8_Football%20Court%20Sparkling%20minds%20%205.jpg'
      ]
    }
  ],

  'pickleball-courts': [
    {
      id: 1,
      title: 'Pickle Park (Premium Indoor Pickleball Court)',
      builtArea: '1,800 sq ft',
      location: 'Koppa, Bangalore',
      completionDate: '2025',
      materials: ['Premium Acrylic Court Surface', 'Regulation Net System', 'Professional Court Lines', 'LED Lighting'],
      description: 'Premium indoor pickleball court at Pickle Park with state-of-the-art facilities and professional-grade surface.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/188glq5z_Pickle%20Park%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/fyckihtd_Pickle%20Park%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/xtqvjzz1_Pickle%20Park%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/ln4e7jj8_Pickle%20Park%204.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/8pin9w9i_Pickle%20Park%205.jpg'
      ]
    },
    {
      id: 2,
      title: 'Decathlon (Pickleball Court)',
      builtArea: '2,800 sq ft',
      location: 'Decathlon Sports Store, Bangalore',
      completionDate: '2024',
      materials: ['Professional Court Surface', 'Regulation Net Systems', 'Premium Court Lines', 'LED Court Lighting'],
      description: 'Professional pickleball court installation at Decathlon sports store with regulation specifications and high-quality materials.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/3nqpjjlb_Pickleball%20Courts%20Decathlon%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/2ok6o2cv_Pickleball%20Courts%20Decathlon%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/ogtez7wj_Pickleball%20Courts%20Decathlon%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/7oj1uav1_Pickleball%20Courts%20Decathlon%204.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/d4b0trvx_Pickleball%20Courts%20Decathlon%205.jpg'
      ]
    },
    {
      id: 3,
      title: 'Athlevate Sports (Pickleball Court)',
      builtArea: '4,350 sq ft',
      location: 'Chokkanahalli, Bangalore',
      completionDate: '2025',
      materials: ['Premium Court Surface', 'Professional Net System', 'Court Lighting', 'Boundary Markings'],
      description: 'Professional pickleball court installation at Athlevate Sports facility with regulation specifications and premium materials.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/bl1sjrrd_Pickleball%20Court%20Athlevate%20Sportss%201%20.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/if4rfqyf_Pickleball%20Court%20Athlevate%20Sportss%202%20.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/yuco7ufe_Pickleball%20Court%20Athlevate%20Sportss%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/irizcm6l_Pickleball%20Court%20Athlevate%20Sportss%204.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/7tglocta_Pickleball%20Court%20Athlevate%20Sportss%205.jpg'
      ]
    },
    {
      id: 4,
      title: 'Hive Club (Pickleball Court)',
      builtArea: '13,244 sq ft',
      location: 'Thanisandra, Bangalore',
      completionDate: '2025',
      materials: ['Acrylic Court Surface', 'Regulation Net System', 'Court Line Paint', 'LED Lighting'],
      description: 'Tournament-standard pickleball court with regulation dimensions and professional surface.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/2bnqcck4_Pickleball%20Court%20in%20Bangalore%20hive%20club%20right%20shade%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/o5s69788_Pickleball%20Court%20in%20Bangalore%20hive%20club%20right%20shade%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/5yiz92sc_Pickleball%20Court%20in%20Bangalore%20hive%20club%20right%20shade%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/43k23r7q_Pickleball%20Court%20in%20Bangalore%20hive%20club%20right%20shade%204.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/kwvtc5co_Pickleball%20Court%20in%20Bangalore%20hive%20club%20right%20shade%205.jpg'
      ]
    }
  ],

  'volleyball-courts': [
    {
      id: 1,
      title: 'Bengaluru Torpedoes Academy (Volleyball Court)',
      builtArea: '1,400 sq ft',
      location: 'Bangalore',
      completionDate: '2025',
      materials: ['Wooden Sports Flooring', 'Professional Net System', 'Court Markings', 'LED Lighting'],
      description: 'Professional volleyball court at Bengaluru Torpedoes Academy with regulation dimensions and premium sports flooring.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/lo0nzkro_Bengaluru%20torpedoes%20academy%20Volleyball%20court%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/esyyvgtj_Bengaluru%20torpedoes%20academy%20Volleyball%20court%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/bouai8us_Bengaluru%20torpedoes%20academy%20Volleyball%20court%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/a8fe59xe_Bengaluru%20torpedoes%20academy%20Volleyball%20court%204.jpg'
      ]
    }
  ],

  'padel-courts': [
    {
      id: 1,
      title: 'Hive Club (Padel Court)',
      builtArea: '2,278 sq ft',
      location: 'Thanisandra, Bangalore',
      completionDate: '2025',
      materials: ['Artificial Grass Surface', 'Glass Walls', 'LED Lighting', 'Professional Net'],
      description: 'Professional padel court at Hive Club with regulation dimensions and premium artificial grass surface.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/0yfsr8sr_Padle%20Court%20hive%20club%20%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/0srfio0f_Padle%20Court%20hive%20club%20%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/4v0hwyct_Padle%20Court%20hive%20club%20%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/x6l7ntga_Padle%20Court%20hive%20club%20%204.jpg'
      ]
    }
  ],

  'athlete-track': [
    {
      id: 1,
      title: 'Jahlali Airforce Synthetic Track',
      builtArea: '43,300 sq ft',
      location: 'Bangalore',
      completionDate: '2023',
      materials: ['Professional Synthetic Track Surface', 'Multi-Lane Configuration', 'Starting Blocks', 'Field Equipment'],
      description: 'Professional synthetic athletic track at Jahlali Airforce with multi-lane configuration and complete facilities.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/mckksgn6_Athletic%20Tracks%20Airforce%20synthetic%20track%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/82c17f4x_Athletic%20Tracks%20Airforce%20synthetic%20track%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/agrr3lfi_Athletic%20Tracks%20Airforce%20synthetic%20track%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/8fi4o1qa_Athletic%20Tracks%20Airforce%20synthetic%20track%204.jpg'
      ]
    }
  ],

  'basketball-courts': [
    {
      id: 1,
      title: 'HSR (Basketball Court)',
      builtArea: '5,400 sq ft',
      location: 'HSR Layout, Bangalore',
      completionDate: '2023',
      materials: ['Premium Court Flooring', 'Professional Backboards', 'Adjustable Hoops', 'LED Court Lighting'],
      description: 'Professional basketball court at HSR with premium flooring and state-of-the-art facilities.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/3rsm0bt1_Game%20theory%20HSR%20basketball%20court%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/8963covz_Game%20theory%20HSR%20basketball%20court%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/s3yubjow_Game%20theory%20HSR%20basketball%20court%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/tyeabvn3_Game%20theory%20HSR%20basketball%20court%204.jpg'
      ]
    }
  ],

  'volleyball-courts': [
    {
      id: 1,
      title: 'Bengaluru Torpedoes Academy (Volleyball Court)',
      builtArea: '1,400 sq ft',
      location: 'Bangalore',
      completionDate: '2025',
      materials: ['Wooden Sports Flooring', 'Professional Net System', 'Court Markings', 'LED Lighting'],
      description: 'Professional volleyball court at Bengaluru Torpedoes Academy with regulation dimensions and premium sports flooring.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/lo0nzkro_Bengaluru%20torpedoes%20academy%20Volleyball%20court%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/esyyvgtj_Bengaluru%20torpedoes%20academy%20Volleyball%20court%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/bouai8us_Bengaluru%20torpedoes%20academy%20Volleyball%20court%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/a8fe59xe_Bengaluru%20torpedoes%20academy%20Volleyball%20court%204.jpg'
      ]
    }
  ],

  'squash-courts': [
    {
      id: 1,
      title: 'Koramangala (Squash Court)',
      builtArea: '704 sq ft',
      location: 'Koramangala, Bangalore',
      completionDate: '2025',
      materials: ['Premium Flooring', 'Tempered Glass Wall', 'Professional Lighting', 'Ventilation System'],
      description: 'Professional squash court at Koramangala with regulation dimensions and glass back wall.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/wwzv3sy6_Squash%20Court%20game%20theory%20HSR%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/zu7l5s5q_Squash%20Court%20game%20theory%20HSR%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/780f79zd_Squash%20Court%20game%20theory%20HSR%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/u3dvrda9_Squash%20Court%20game%20theory%20HSR%204.jpg'
      ]
    }
  ],

  'cricket-turf': [
    {
      id: 1,
      title: 'Bagalur Sports Arena (Box Cricket)',
      builtArea: '6,175 sq ft',
      location: 'Bagalur, Bangalore',
      completionDate: '2025',
      materials: ['Artificial Turf', 'Box Cricket Setup', 'Boundary Nets', 'LED Lighting'],
      description: 'Professional box cricket facility at Bagalur Sports Arena with artificial turf and modern lighting systems.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/22dpkvf1_Cricket%20turf%20Baglur%20sports%20arena%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/6vbwr6y7_Cricket%20turf%20Baglur%20sports%20arena%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/mc4tpptr_Cricket%20turf%20Baglur%20sports%20arena%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/cf5u392v_Cricket%20turf%20Baglur%20sports%20arena%204.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/ketxjjso_Cricket%20turf%20Baglur%20sports%20arena%205.jpg'
      ]
    }
  ],

  // Construction Services
  'warehouse': [
    {
      id: 1,
      title: 'Peenya Warehouse',
      builtArea: '50,000 sq ft',
      location: 'Peenya, Bangalore',
      completionDate: 'December 2024',
      materials: ['Pre-engineered Steel', 'Industrial Flooring', 'Modern Infrastructure', 'Security Systems'],
      description: 'Top-quality warehouse construction in Peenya industrial area with modern facilities and infrastructure.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/43sx4uhq_Top%20Warehouse%20contruction%20in%20bangalore%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/ysnbgg4a_Top%20Warehouse%20contruction%20in%20bangalore%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/4yax3h66_Top%20Warehouse%20contruction%20in%20bangalore%203.jpg'
      ]
    }
  ],

  'court-structures': [
    {
      id: 1,
      title: 'Picklepark (Court Structure)',
      builtArea: '2,400 sq ft',
      location: 'Bangalore',
      completionDate: '2025',
      materials: ['Steel Structure', 'Professional Roofing', 'LED Lighting System', 'Safety Features'],
      description: 'Complete court structure and infrastructure for Picklepark with professional roofing and lighting systems.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/o1y2gqoz_pickleball%20structure%20makers%20in%20bangalore%201.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/hfpiibda_pickleball%20structure%20makers%20in%20bangalore%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/730jse2g_pickleball%20structure%20makers%20in%20bangalore%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/1i0802cv_pickleball%20structure%20makers%20in%20bangalore%204.jpg'
      ]
    },
    {
      id: 2,
      title: 'Hive Club (Court Structure)',
      builtArea: '13,000 sq ft',
      location: 'Thanisandra, Bangalore',
      completionDate: '2025',
      materials: ['Steel Framework', 'Modern Roofing', 'Professional Lighting', 'Sports Infrastructure'],
      description: 'Professional court structure and infrastructure development for Hive Club sports facility.',
      images: [
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/7nz1ik88_Court%20structure%20makers%20in%20bangalore.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/p2q1v2k0_Court%20structure%20makers%20in%20bangalore%202.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/4vpltfrj_Court%20structure%20makers%20in%20bangalore%203.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/559yxqwd_Court%20structure%20makers%20in%20bangalore%204.jpg',
        'https://customer-assets.emergentagent.com/job_remove-emergent-3/artifacts/j1v74ssv_Court%20structure%20makers%20in%20bangalore%205.jpg'
      ]
    }
  ]
};

// Service categories and their display names
export const serviceCategories = {
  sports: {
    'pickleball-courts': 'Pickleball Courts',
    'football-turf': 'Football Turf',
    'cricket-turf': 'Cricket Turf',
    'padel-courts': 'Padel Courts',
    'badminton-courts': 'Badminton Courts',
    'athlete-track': 'Athlete Track',
    'basketball-courts': 'Basketball Courts',
    'volleyball-courts': 'Volleyball Courts',
    'squash-courts': 'Squash Courts',
    'tennis-courts': 'Tennis Courts'
  },
  construction: {
    'warehouse': 'Warehouse',
    'court-structures': 'Court Structures'
  }
};